import { api } from "@/redux/api";

import {
	CreateSubTaskTemplate,
	CreateTaskTemplate,
	SubTaskTemplateInfo,
	SubTaskTemplateInfoSchema,
	TaskTemplateArraySchema,
	TaskTemplateInfo,
	TaskTemplateInfoSchema,
	UpdateSubTaskTemplate,
	UpdateTaskTemplate,
} from "../../pages/ManageTaskTemplates/schema/task-template";

export const taskTemplateApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTaskTemplates: builder.query<TaskTemplateInfo[], void>({
			query: () => ({
				url: "task-templates",
				responseSchema: TaskTemplateArraySchema,
			}),
			providesTags: ["TaskTemplates"],
		}),

		getTaskTemplateById: builder.query<TaskTemplateInfo, number>({
			query: (id) => ({
				url: `task-templates/${id}`,
				responseSchema: TaskTemplateInfoSchema,
			}),
			providesTags: (_result, _error, id) => [{ type: "TaskTemplates", id }],
		}),

		createTaskTemplate: builder.mutation<TaskTemplateInfo, CreateTaskTemplate>({
			query: (body) => ({
				url: "task-templates",
				method: "POST",
				body,
				responseSchema: TaskTemplateInfoSchema,
			}),
			invalidatesTags: ["TaskTemplates"],
		}),

		updateTaskTemplate: builder.mutation<TaskTemplateInfo, UpdateTaskTemplate>({
			query: ({ id, ...body }) => ({
				url: `task-templates/${id}`,
				method: "PATCH",
				body,
				responseSchema: TaskTemplateInfoSchema,
			}),
			invalidatesTags: (_result, _error, { id }) => [
				"TaskTemplates",
				{ type: "TaskTemplates", id },
			],
		}),

		deleteTaskTemplate: builder.mutation<void, number>({
			query: (id) => ({
				url: `task-templates/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["TaskTemplates"],
		}),

		createSubTaskTemplate: builder.mutation<SubTaskTemplateInfo, CreateSubTaskTemplate>({
			query: ({ taskTemplateId, ...body }) => ({
				url: `task-templates/${taskTemplateId}/sub-task-templates`,
				method: "POST",
				body,
				responseSchema: SubTaskTemplateInfoSchema,
			}),
			invalidatesTags: ["TaskTemplates"],
		}),

		updateSubTaskTemplate: builder.mutation<SubTaskTemplateInfo, UpdateSubTaskTemplate>({
			query: ({ taskTemplateId, id, ...body }) => ({
				url: `task-templates/${taskTemplateId}/sub-task-templates/${id}`,
				method: "PATCH",
				body,
				responseSchema: SubTaskTemplateInfoSchema,
			}),
			invalidatesTags: ["TaskTemplates"],
		}),

		deleteSubTaskTemplate: builder.mutation<void, { taskTemplateId: number; id: number }>({
			query: ({ taskTemplateId, id }) => ({
				url: `task-templates/${taskTemplateId}/sub-task-templates/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["TaskTemplates"],
		}),
	}),
});

export const {
	useGetTaskTemplatesQuery,
	useGetTaskTemplateByIdQuery,
	useCreateTaskTemplateMutation,
	useUpdateTaskTemplateMutation,
	useDeleteTaskTemplateMutation,
	useCreateSubTaskTemplateMutation,
	useUpdateSubTaskTemplateMutation,
	useDeleteSubTaskTemplateMutation,
} = taskTemplateApi;

export const taskTemplateReducer = taskTemplateApi.reducer;
export const taskTemplateMiddleware = taskTemplateApi.middleware;
